//const urlBase = 'http://localhost/cl-etalentos-backend/';
const urlBase = 'https://backend-escueladetalentospedagogicos.ucsc.cl/';

export default urlBase;
